/**
 * Centralised CPD React-Query cache keys — the ONE declaration site.
 *
 * Three of these eleven literals already lived in a dedicated file at the old
 * app path, for a reason the carve generalises: a consumer that only wants to
 * invalidate a cache should not have to pull in the hook module, which drags
 * the whole transport graph behind it. The other eight were declared inside
 * their own hooks, so every cross-hook invalidation (settings invalidating
 * activities, submissions invalidating drafts) imported a hook for a string.
 *
 * Declaring all eleven here is what makes the keys readable from the inert
 * `/contracts` door, and it is also what the cache-key lock asks for: one
 * identity, one declaration. The hooks IMPORT them and never re-export them.
 *
 * The literals are byte-identical to their pre-move values — these strings are
 * persisted cache identities, so a typo silently splits a cache rather than
 * failing a build. `cpd-query-keys.test.ts` pins all eleven.
 */

export const CPD_ACTIVITIES_KEY = 'cpd_activities';
export const CPD_DRAFTS_KEY = 'cpd_drafts';
export const CPD_EXPORT_KEY = 'cpd_export';
export const CPD_HOMEPAGE_KEY = 'cpd_homepage';
export const CPD_JOURNALS_KEY = 'cpd_journals';
export const CPD_SAVED_SOURCES_KEY = 'cpd_saved_sources';
export const CPD_SETTINGS_KEY = 'cpd_settings';
export const CPD_SOURCES_INFINITE_KEY = 'cpd_sources_infinite';
export const CPD_SOURCES_KEY = 'cpd_sources';
export const CPD_STATS_KEY = 'cpd_stats';
export const CPD_SUBMISSIONS_KEY = 'cpd_submissions';
